import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CheckCircle, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaConclusaoProfissional = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('concluiu demanda');
};

const getIconConclusaoProfissional = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: CheckCircle, color: 'var(--c10b981)' };
};

export default function CardConclusaoProfissional({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconConclusaoProfissional(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const conclusaoProfissionalConfig = {
    tipo: 'conclusao_profissional',
    detectaTipo: detectaConclusaoProfissional,
    getIcon: getIconConclusaoProfissional,
    temExpansao: () => true,
    Component: CardConclusaoProfissional
};

